// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SignatureV1EmailSignatureTemplateCreateEnvelopeCreateEnvelopeResponse {
    static getAttributeTypeMap() {
        return SignatureV1EmailSignatureTemplateCreateEnvelopeCreateEnvelopeResponse.attributeTypeMap;
    }
}
SignatureV1EmailSignatureTemplateCreateEnvelopeCreateEnvelopeResponse.discriminator = undefined;
SignatureV1EmailSignatureTemplateCreateEnvelopeCreateEnvelopeResponse.additionalProperties = false;
SignatureV1EmailSignatureTemplateCreateEnvelopeCreateEnvelopeResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "EmailSignatureTemplateResponse"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=signatureV1EmailSignatureTemplateCreateEnvelopeCreateEnvelopeResponse.js.map